
<body>
  <div class="wrapper">
        <!-- Sidebar -->
        <div class="sidebar" data-background-color="dark">
          <div class="sidebar-logo">
            <!-- Logo Header -->
            <div class="logo-header" data-background-color="dark">
              <a href="home/" class="logo">
                <img
                  src="assets/manage-complaints.png"
                  alt="navbar brand"
                  class="navbar-brand"
                  height="120"
                />
              </a>
              <div class="nav-toggle">
                <button class="btn btn-toggle toggle-sidebar">
                  <i class="gg-menu-right"></i>
                </button>
                <button class="btn btn-toggle sidenav-toggler">
                  <i class="gg-menu-left"></i>
                </button>
              </div>
              <button class="topbar-toggler more">
                <i class="gg-more-vertical-alt"></i>
              </button>
            </div>
            <!-- End Logo Header -->
          </div>
          <div class="sidebar-wrapper scrollbar scrollbar-inner">
            <div class="sidebar-content">
              <ul class="nav nav-secondary">
                <!-- Home Link -->
                <li class="nav-item">
                  <a class="nav-link hidden-arrow" role="button" aria-expanded="false" routerLink="/home">
                    Accueil
                  </a>
                </li>
              
                <!-- Réclamations Section for metierbanque and adminbanque profiles -->
                <li class="nav-item" *ngIf="returnprofil() === 'metierbanque' || returnprofil() === 'adminbanque'">
                  <a href="#reclamationMetierAdmin" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                    <i class="fas fa-users"></i>
                    <p>Réclamations</p>
                    <span class="caret"></span>
                  </a>
                  <div class="collapse" id="reclamationMetierAdmin">
                    <ul class="nav nav-collapse">
                      <li><a routerLink="transaction/view-compconfs" routerLinkActive="active"><span class="sub-item">Initiation de réclamation</span></a></li>
                      <li><a routerLink="dashboard/user-board/onus" routerLinkActive="active"><span class="sub-item">Traitement de réclamations Onus</span></a></li>
                      <li><a routerLink="dashboard/user-board/eme" routerLinkActive="active"><span class="sub-item">Traitement de réclamations émises</span></a></li>
                      <li><a routerLink="dashboard/user-board/acq" routerLinkActive="active"><span class="sub-item">Traitement de réclamations reçues</span></a></li>

                    </ul>
                  </div>
                </li>
              
                <!-- Réclamations Section for porteur, commercant, and agence profiles -->
                <li class="nav-item" *ngIf="returnprofil() === 'porteur' || returnprofil() === 'commercant' || returnprofil() === 'agence'">
                  <a href="#reclamationPorteurCommercantAgence" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                    <i class="fas fa-compass"></i>
                    <p>Réclamations</p>
                    <span class="caret"></span>
                  </a>
                  <div class="collapse" id="reclamationPorteurCommercantAgence">
                    <ul class="nav nav-collapse">
                      <li><a routerLink="transaction/view-compconfs" routerLinkActive="active"><span class="sub-item">Initiation de réclamation</span></a></li>
                      <li><a routerLink="dashboard/user-board" routerLinkActive="active"><span class="sub-item">Suivi des réclamations</span></a></li>
                    </ul>
                  </div>
                </li>
              
                <!-- Réclamations Section for comite profile -->
                <li class="nav-item" *ngIf="returnprofil() === 'presidentcomite'||returnprofil() === 'membrecomite'">
                  <a href="#reclamationComite" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                    <i class="fas fa-university"></i>
                    <p>Réclamations</p>
                    <span class="caret"></span>
                  </a>
                  <div class="collapse" id="reclamationComite">
                    <ul class="nav nav-collapse">
                      <li><a routerLink="dashboard/user-board" routerLinkActive="active"><span class="sub-item">Suivi des réclamations</span></a></li>
                    </ul>
                  </div>
                </li>
              
                <!-- Travaux journée for metierbanque and adminbanque profiles -->
                <li class="nav-item" *ngIf="returnprofil() === 'metierbanque' || returnprofil() === 'adminbanque'">
                  <a href="#travaux" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                    <i class="fas fa-address-card"></i>
                    <p>Travaux journée</p>
                    <span class="caret"></span>
                  </a>
                  <div class="collapse" id="travaux">
                    <ul class="nav nav-collapse">
                      <li><a routerLink="transaction/insert-compconf" routerLinkActive="active"><span class="sub-item">Espace Insérer compconf</span></a></li>
                      <li><a routerLink="core/settings" routerLinkActive="active"><span class="sub-item">Génération Out</span></a></li>
                    </ul>
                  </div>
                </li>
              
                <!-- espace utilisateur for porteur, commercant-->
                <li class="nav-item" *ngIf="returnprofil() === 'porteur' || returnprofil() === 'commercant'|| returnprofil() === 'agence'">
                  <a href="#doc" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                    <i class="fas fa-address-book"></i>
                    <p>Espace utilisateur</p>
                    <span class="caret"></span>
                  </a>
                  <div class="collapse" id="doc">
                    <ul class="nav nav-collapse">
                      <li><a routerLink="core/view-documents" routerLinkActive="active"><span class="sub-item">Consulter les documents</span></a></li>
                    </ul>
                  </div>
                </li>
                           
                <!-- Espace utilisateur for adminbanque profile -->
                <li class="nav-item" *ngIf="returnprofil() === 'adminbanque'||returnprofil() === 'presidentcomite'||returnprofil() === 'metierbanque'" >
                  <a href="#espaceAdminBanque" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                    <i class="fas fa-cog"></i>
                    <p>Espace utilisateur</p>
                    <span class="caret"></span>
                  </a>
                  <div class="collapse" id="espaceAdminBanque">
                    <ul class="nav nav-collapse" style="padding-left: 10%;">
                      <li class="submenu-item">
                        <a href="#gestionusers" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                                    <i class="fas fa-chevron-right"></i>
                                    <p>Paramêtrage général</p>
                                    <span class="caret"></span>
                                  </a>
                                  <div class="collapse" id="gestionusers">
                                    <ul class="nav nav-collapse">
                <li><a routerLink="/auth/signup/" routerLinkActive="active"><span class="sub-item">Ajouter utilisateur</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/consultusers" routerLinkActive="active"><span class="sub-item">Gérer utilisateurs</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/multiusers" routerLinkActive="active"><span class="sub-item">Ajouter plusieurs utilisateurs</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/multiporteurs" routerLinkActive="active"*ngIf="returnprofil() !== 'presidentcomite'"><span class="sub-item">Ajout des fichiers compte/carte</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/multimerchants" routerLinkActive="active"*ngIf="returnprofil() !== 'presidentcomite'"><span class="sub-item">Ajout des fichiers compte/Id commercants</span></a></li>
                                    </ul>
                                  </div>
                    </li>
                      <li class="submenu-item">
                        <a routerLink="core/view-documents" routerLinkActive="active">
                          <i class="fas fa-chevron-right"></i>
                          <p>Consulter les documents</p>
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>           
                <!-- Espace utilisateur for superadmin profile -->
                <li class="nav-item" *ngIf="returnprofil() === 'superadmin'">
                  <a href="#espaceSuperAdmin" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                    <i class="fas fa-address-book"></i>
                    <p>Espace utilisateur</p>
                    <span class="caret"></span>
                  </a>
                  <div class="collapse" id="espaceSuperAdmin">
                    <ul class="nav nav-collapse">
                      <li><a routerLink="core/add-motif" routerLinkActive="active"><span class="sub-item">Paramètres réclamations</span></a></li>
                      <li><a routerLink="core/view-documents" routerLinkActive="active"><span class="sub-item">Consulter les documents</span></a></li>
                      <li class="submenu-item">
                                  <a href="#gestionusers" data-bs-toggle="collapse" class="collapsed" aria-expanded="false">
                                    <i class="fas fa-cog"></i>
                                    <p>Paramêtrage général</p>
                                    <span class="caret"></span>
                                  </a>
                                  <div class="collapse" id="gestionusers">
                                    <ul class="nav nav-collapse">
                <li><a routerLink="/auth/signup/" routerLinkActive="active"><span class="sub-item">Ajouter utilisateur</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/consultusers" routerLinkActive="active"><span class="sub-item">Gérer utilisateurs</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/multiusers" routerLinkActive="active"><span class="sub-item">Ajouter plusieurs utilisateurs</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/multiporteurs" routerLinkActive="active"><span class="sub-item">Ajout des fichiers compte/carte</span></a></li>
                <li><a class="submenu-item" routerLink="/dashboard/admin-board/multimerchants" routerLinkActive="active"><span class="sub-item">Ajout des fichiers compte/Id commercants</span></a></li>
                                    </ul>
                                  </div>
                      </li>
                    </ul>
                  </div>
                </li>

              <!-- Espace tasks for all users -->
              <li class="nav-item"*ngIf="isLoggedIn">
                          <a routerLink="tasks" routerLinkActive="active">
                            <i class="fas fa-tasks"></i>
                            <p>Tableau de bord utilisateur</p>
                          </a>
              </li>
              </ul>            
            </div>
          </div>
        </div>
        <div class="main-panel">
          <div class="main-header">
            <div class="main-header-logo">
              <!-- Logo Header -->
              <div class="logo-header" data-background-color="dark">
                <a href="home/" class="logo">
                  <img
                    src="assets/manage-complaints.png"
                    alt="navbar brand"
                    class="navbar-brand"
                    height="120"
                  />
                </a>
                <div class="nav-toggle">
                  <button class="btn btn-toggle toggle-sidebar">
                    <i class="gg-menu-right"></i>
                  </button>
                  <button class="btn btn-toggle sidenav-toggler">
                    <i class="gg-menu-left"></i>
                  </button>
                </div>
                <button class="topbar-toggler more">
                  <i class="gg-more-vertical-alt"></i>
                </button>
              </div>
              <!-- End Logo Header -->
            </div>
            <!-- Navbar Header -->
            <nav
              class="navbar navbar-header navbar-header-transparent navbar-expand-lg border-bottom"
            >
              <div class="container-fluid">
                <nav
                  class="navbar navbar-header-left navbar-expand-lg navbar-form nav-search p-0 d-none d-lg-flex"
                >
                <strong>Date systeme actuelle : {{currentdate | customDate}}</strong>
                </nav>
        
                <ul class="navbar-nav topbar-nav ms-md-auto align-items-center">
                  <li
                    class="nav-item topbar-icon dropdown hidden-caret d-flex d-lg-none"
                  >
                  <strong>Date systeme actuelle : {{currentdate | customDate}}</strong>

                    <a
                      class="nav-link dropdown-toggle"
                      data-bs-toggle="dropdown"
                      href="#"
                      role="button"
                      aria-expanded="false"
                      aria-haspopup="true"
                    >
                  </a>
                  </li>
            
                  <li class="nav-item topbar-icon dropdown hidden-caret">
                    <a
                      class="nav-link dropdown-toggle"
                      href="#"
                      id="messageDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa fa-envelope"></i>
                    </a>
                    <ul
                      class="dropdown-menu messages-notif-box animated fadeIn"
                      aria-labelledby="messageDropdown"
                    >
                      <li>
                        <div
                          class="dropdown-title d-flex justify-content-between align-items-center"
                        >
                          Messages
                          <a href="#" class="small">Mark all as read</a>
                        </div>
                      </li>
                      <li>
                        <div class="message-notif-scroll scrollbar-outer">
                          <div class="notif-center">
                            <a href="#">
                              <div class="notif-img">
                                <img
                                  src="assets/img/jm_denis.jpg"
                                  alt="Img Profile"
                                />
                              </div>
                              <div class="notif-content">
                                <span class="subject">Jimmy Denis</span>
                                <span class="block"> How are you ? </span>
                                <span class="time">5 minutes ago</span>
                              </div>
                            </a>
                            <a href="#">
                              <div class="notif-img">
                                <img
                                  src="assets/img/chadengle.jpg"
                                  alt="Img Profile"
                                />
                              </div>
                              <div class="notif-content">
                                <span class="subject">Chad</span>
                                <span class="block"> Ok, Thanks ! </span>
                                <span class="time">12 minutes ago</span>
                              </div>
                            </a>
                            <a href="#">
                              <div class="notif-img">
                                <img
                                  src="assets/img/mlane.jpg"
                                  alt="Img Profile"
                                />
                              </div>
                              <div class="notif-content">
                                <span class="subject">Jhon Doe</span>
                                <span class="block">
                                  Ready for the meeting today...
                                </span>
                                <span class="time">12 minutes ago</span>
                              </div>
                            </a>
                            <a href="#">
                              <div class="notif-img">
                                <img
                                  src="assets/img/talha.jpg"
                                  alt="Img Profile"
                                />
                              </div>
                              <div class="notif-content">
                                <span class="subject">Talha</span>
                                <span class="block"> Hi, Apa Kabar ? </span>
                                <span class="time">17 minutes ago</span>
                              </div>
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <a class="see-all" href="javascript:void(0);"
                          >See all messages<i class="fa fa-angle-right"></i>
                        </a>
                      </li>
                    </ul>
                  </li>
             
                  <li class="nav-item topbar-icon dropdown hidden-caret">
                    <a
                      class="nav-link dropdown-toggle"
                      href="#"
                      id="notifDropdown"
                      role="button"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fa fa-bell"></i>
                      <span class="notification">{{totalnotifs}}</span>
                    </a>
                    <ul
                      class="dropdown-menu notif-box animated fadeIn"
                      aria-labelledby="notifDropdown"
                    >
                      <li>
                        <div class="dropdown-title">
                          You have {{totalnotifs}} new notification
                        </div>
                      </li>
                      <li>
                        <div class="notif-scroll scrollbar-outer">
                          <div class="notif-center" *ngFor="let not of notifs; let i = index">
                            <a (click)="getnavigation(not.id)">
                              <div class="notif-icon notif-primary">
                                <i class="fa fa-user-plus"></i>
                              </div>
                              <div class="notif-content">
                                <span class="block"> {{not.message}} </span>
                                <span class="time">{{not.createdAt}}</span>
                              </div>
                            </a>
                          </div>
                        </div>
                      </li>
                      <li>
                        <a class="see-all" href="javascript:void(0);"
                          >See all notifications<i class="fa fa-angle-right"></i>
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li class="nav-item topbar-icon dropdown hidden-caret">
                    <a
                      class="nav-link"
                      data-bs-toggle="dropdown"
                      href="#"
                      aria-expanded="false"
                    >
                      <i class="fas fa-layer-group"></i>
                    </a>
                    <div class="dropdown-menu quick-actions animated fadeIn">
                      <div class="quick-actions-header">
                        <span class="title mb-1">Quick Actions</span>
                        <span class="subtitle op-7">Shortcuts</span>
                      </div>
                      <div class="quick-actions-scroll scrollbar-outer">
                        <div class="quick-actions-items">
                          <div class="row m-0">
                            <a class="col-6 col-md-4 p-0" href="#">
                              <div class="quick-actions-item">
                                <div class="avatar-item bg-danger rounded-circle">
                                  <i class="far fa-calendar-alt"></i>
                                </div>
                                <span class="text">Calendar</span>
                              </div>
                            </a>
                            <a class="col-6 col-md-4 p-0" href="#">
                              <div class="quick-actions-item">
                                <div
                                  class="avatar-item bg-warning rounded-circle"
                                >
                                  <i class="fas fa-map"></i>
                                </div>
                                <span class="text">Maps</span>
                              </div>
                            </a>
                            <a class="col-6 col-md-4 p-0" href="#">
                              <div class="quick-actions-item">
                                <div class="avatar-item bg-info rounded-circle">
                                  <i class="fas fa-file-excel"></i>
                                </div>
                                <span class="text">Reports</span>
                              </div>
                            </a>
                            <a class="col-6 col-md-4 p-0" href="#">
                              <div class="quick-actions-item">
                                <div
                                  class="avatar-item bg-success rounded-circle"
                                >
                                  <i class="fas fa-envelope"></i>
                                </div>
                                <span class="text">Emails</span>
                              </div>
                            </a>
                            <a class="col-6 col-md-4 p-0" href="#">
                              <div class="quick-actions-item">
                                <div
                                  class="avatar-item bg-primary rounded-circle"
                                >
                                  <i class="fas fa-file-invoice-dollar"></i>
                                </div>
                                <span class="text">Invoice</span>
                              </div>
                            </a>
                            <a class="col-6 col-md-4 p-0" href="#">
                              <div class="quick-actions-item">
                                <div
                                  class="avatar-item bg-secondary rounded-circle"
                                >
                                  <i class="fas fa-credit-card"></i>
                                </div>
                                <span class="text">Payments</span>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li class="nav-item topbar-icon dropdown hidden-caret"*ngIf="!isLoggedIn">
                    <a
                      class="nav-link"
                      data-bs-toggle="dropdown"
                      (click)="gotologin()"
                      aria-expanded="false"
                    >
                      <i class="icon-login"></i>
                    </a>
                  </li>  
                  <li class="nav-item topbar-user dropdown hidden-caret" *ngIf="isLoggedIn">
                    <a
                      class="dropdown-toggle profile-pic"
                      data-bs-toggle="dropdown"
                      href="#"
                      aria-expanded="false"
                    >
                      <div class="avatar-sm">
                        <img
                          src="assets/img/profile.jpg"
                          alt="..."
                          class="avatar-img rounded-circle"
                        />
                      </div>
                      <span class="profile-username">
                        <strong class="op-7">Bienvenue,</strong>
                        <span *ngIf="usertype == 'Clientpor'" class="d-none d-sm-block ms-1">Porteur&nbsp;{{carte | truncatecard}}</span>
                        <span *ngIf="usertype == 'Clientcomm'" class="d-none d-sm-block ms-1">Commerçant&nbsp;{{affiliation}}</span>
                        <span *ngIf="usertype == 'Agence'" class="d-none d-sm-block ms-1">Agence&nbsp;{{indicatifagence}}</span>
                        <span *ngIf="usertype == 'comite arbitrage'" class="d-none d-sm-block ms-1">Comité arbitrage&nbsp;{{role}}</span>
                        <span *ngIf="role == 'adminbanque'" class="d-none d-sm-block ms-1">Admin Banque&nbsp;{{codebanque |changebanque}}</span>
                        <span *ngIf="role == 'superadmin'" class="d-none d-sm-block ms-1">Super Admin&nbsp;{{codebanque}}</span>
                        <span *ngIf="role == 'userbanque'&&usertype == 'Metier'" class="d-none d-sm-block ms-1">Utilisateur Banque&nbsp;{{codebanque |changebanque}}</span>
                  
                      </span>
                    </a>
                    <ul class="dropdown-menu dropdown-user animated fadeIn">
                      <div class="dropdown-user-scroll scrollbar-outer">
                        <li>
                          <div class="user-box">
                            <div class="avatar-lg">
                              <img
                                src="assets/img/profile.jpg"
                                alt="image profile"
                                class="avatar-img rounded"
                              />
                            </div>
                            <div class="u-text">
                              <h4 *ngIf="usertype == 'Clientpor'" class="d-none d-sm-block ms-1">Porteur&nbsp;{{carte | truncatecard}}</h4>
                              <h4 *ngIf="usertype == 'Clientcomm'" class="d-none d-sm-block ms-1">Commerçant&nbsp;{{affiliation}}</h4>
                              <h4 *ngIf="usertype == 'Agence'" class="d-none d-sm-block ms-1">Agence&nbsp;{{indicatifagence}}</h4>
                              <h4 *ngIf="usertype == 'comite'" class="d-none d-sm-block ms-1">Comité arbitrage&nbsp;</h4>
                              <h4 *ngIf="role == 'adminbanque'" class="d-none d-sm-block ms-1">Admin Banque&nbsp;{{codebanque |changebanque}}</h4>
                              <h4 *ngIf="role == 'superadmin'" class="d-none d-sm-block ms-1">Super Admin&nbsp;{{codebanque}}</h4>
                              <h4 *ngIf="role == 'userbanque'&&usertype == 'Metier'" class="d-none d-sm-block ms-1">Utilisateur Banque&nbsp;{{codebanque |changebanque}}</h4> 
                              <a
                              routerLink="auth/profil"
                                class="btn btn-xs btn-secondary btn-sm"
                                >View Profile</a
                              >
                            </div>
                          </div>
                        </li>
                        <li>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" routerLink="auth/profil">My Profile</a>
                         <!--
                          <a class="dropdown-item" href="#">My Balance</a>
                          <a class="dropdown-item" href="#">Inbox</a>
                          <div class="dropdown-divider"></div>
                          <a class="dropdown-item" href="#">Account Setting</a>
                          <div class="dropdown-divider"></div>
                         --> 
                          <a class="dropdown-item" (click)="logout()">Logout</a>
                        </li>
                      </div>
                    </ul>
                  </li>
                </ul>
              </div>
            </nav>
            <!-- End Navbar -->
          </div>
          <div class="container-fluid">
            <div class="page-inner">
              <div
              class="d-flex align-items-left align-items-md-center flex-column flex-md-row pt-2 pb-4"
            >
              <div>
                <h3 class="fw-bold mb-3"></h3>
                <h6 class="op-7 mb-2"></h6>
              </div>
              <div class="ms-md-auto py-2 py-md-0">
                <a href="#" class="btn btn-label-info btn-round me-2"></a>
                <a href="#" class="btn btn-primary btn-round"></a>
              </div>
            </div>
              <router-outlet></router-outlet>
          </div>
          </div>
        <footer class="footer">
          <div class="container-fluid d-flex justify-content-between">
            <nav class="pull-left">
              <ul class="nav">
                <li class="nav-item">
                  <a class="nav-link" href="#"> Help </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#"> Licenses </a>
                </li>
              </ul>
            </nav>
            <div class="copyright">
              2025, made with <i class="fa fa-heart heart text-danger"></i> by
              <a href="https://manage-complaints.netlify.app/">PGL</a>
            </div>
        
          </div>
        </footer>
        </div>
  </div>
</body>